export default __webpack_public_path__ + "static/media/rt-team-2-matt.5697c10a.png";